import { iconsDetailsProyect } from "../../../../assets/icons/detailsProject";
import { getColorByConsume } from "../../../../types/schemesColors";
import { truncateFloat } from "../../../../helpers/generalHelper";
import CardProjectFicheHrs1 from "./CardProjectFicheHrs1";


const PrimaryCard = ({ percentage, subtract }) => {
    return (
        <>
            <CardProjectFicheHrs1
                title="Consumo"
                hrs={`${truncateFloat(percentage)}%`}
                img={iconsDetailsProyect.consumo}
                color={getColorByConsume(percentage)}
            />
            <CardProjectFicheHrs1
                title="Tiempo restante disponible"
                hrs={`${truncateFloat(subtract)} hrs`}
                img={iconsDetailsProyect.restanteDisponible}
                color={getColorByConsume(percentage)}
            />
        </>
    );
};

export default PrimaryCard;
